<template>
    <modal width="25" :show-modal="showModal" @close-modal="$emit('close-modal')">
        <div class="delete-modal">
            <div class="flex justify-center">
               <span class="books_wrapper">
                 <img class="w-7/12" src="/icons/books.svg" />
               </span>
            </div>

            <div class="my-6">
                <div class="flex justify-center">
                    <span class="text-sm w-10/12 block">Do you want to create a new booking for this Consolidation?</span>
                </div>
                <div class=" justify-center pt-4">
                     <primary-button @click="openBooking" buttonText="Continue" :loading="false" />
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        openBooking:{},
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
        }
    },

    methods: {
        closeModal() {
            this.$emit("close-modal");
        },
    }
};
</script>

<style scoped>
.delete-modal {
    text-align: center;
}
.books_wrapper{
    @apply w-[60px] h-[60px] bg-secondary-pale rounded-full inline-flex justify-center items-center
}
</style>